import { render, staticRenderFns } from "./KeyboardNumMini.vue?vue&type=template&id=32a3de90"
import script from "./KeyboardNumMini.vue?vue&type=script&lang=js"
export * from "./KeyboardNumMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports